import { render, staticRenderFns } from "./newproduct.vue?vue&type=template&id=32eb28a4&scoped=true"
import script from "./newproduct.vue?vue&type=script&lang=js"
export * from "./newproduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32eb28a4",
  null
  
)

export default component.exports